import { useEffect } from "react";
import { useInRouterContext, useLocation } from "react-router-dom";

export function ScrollToTop() {
  const inRouter = useInRouterContext();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (inRouter) {
      window.scrollTo(0, 0);
    }
  }, [pathname, inRouter]);

  return null;
}
